"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyleReset = exports.GlobalStyle = void 0;
var _styledComponents = require("styled-components");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var fontFamily = (0, _styledComponents.css)(["font-family:'IBM Plex Sans','Helvetica Neue',Arial,sans-serif;"]);
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  html[dir=\"rtl\"] {\n    ul, ol {\n      padding-left: 0;\n      padding-right: ", ";\n\n      li:before {\n        left: 0;\n        right: ", ";\n      }\n    }\n  }\n\n  body {\n    letter-spacing: ", ";\n    ", "\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.3px;\n    font-display: fallback;\n  }\n\n  ::-moz-selection {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.space.xl;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "-".concat(theme.typography.li.bulletLeft);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.letterSpacing.default || 0;
}, fontFamily, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.xs;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.regular;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.brandSecondaryContrast;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.brandSecondary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.brandSecondaryContrast;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.brandSecondary;
});
exports.GlobalStyle = GlobalStyle;
var GlobalStyleReset = (0, _styledComponents.createGlobalStyle)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  html {\n    box-sizing: border-box;\n  }\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed, \n  figure, figcaption, footer, header, hgroup, \n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n\n  article, aside, details, figcaption, figure, \n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n\n  body {\n    line-height: 1;\n    font-variant-ligatures: none;\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n\n  blockquote, q {\n    quotes: none;\n  }\n\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: '';\n    content: none;\n  }\n  \n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  img {\n    display: block;\n  }\n\n  button, select {\n    appearance: none;\n    border: none;\n    font: inherit;\n    letter-spacing: inherit;\n    background-color: transparent;\n    padding: 0;\n  }\n\n  textarea, input {\n    font: inherit;\n  }\n"])));
exports.GlobalStyleReset = GlobalStyleReset;